(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopTheLook);
  } else {
    initShopTheLook();
  }

  function initShopTheLook() {
    var container = document.querySelector('.shop-the-look');
    if (!container) return;

    setHeaderHeight();
    initProductCards(container);
    initDesktopHover(container);
    initMobileInteractions(container);
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 961px)').matches;
  }

  function initDesktopHover(container) {
    container.querySelectorAll('.shop-the-look__item').forEach(function (item) {
      var imageWrap = item.querySelector('.shop-the-look__image-wrap');
      var products = item.querySelector('.shop-the-look__products');
      var stage = item.querySelector('.shop-the-look__stage');
      var showTimer = null;

      if (!imageWrap || !stage) return;

      function activate() {
        item.classList.add('is-active');
      }

      function deactivate() {
        clearTimeout(showTimer);
        showTimer = null;
        item.classList.remove('is-active');
      }

      function scheduleActivate() {
        if (!isDesktop()) return;
        clearTimeout(showTimer);
        showTimer = setTimeout(activate, 500);
      }

      imageWrap.addEventListener('mouseenter', scheduleActivate);

      stage.addEventListener('mouseleave', function (event) {
        if (!isDesktop()) return;
        if (stage.contains(event.relatedTarget)) return;
        deactivate();
      });
    });

    window.addEventListener('resize', function () {
      if (!isDesktop()) {
        container.querySelectorAll('.shop-the-look__item.is-active').forEach(function (item) {
          item.classList.remove('is-active');
        });
      }
    });
  }

  function setHeaderHeight() {
    var mobileHeader = document.querySelector('.navigation-mobile');
    var desktopHeader = document.getElementById('header-navigation');
    var activeHeader = isMobile() ? mobileHeader : (desktopHeader || mobileHeader);

    if (!activeHeader) return;

    var height = activeHeader.offsetHeight;
    if (height > 0) {
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
  }

  function isMobile() {
    return window.matchMedia('(max-width: 960px)').matches;
  }

  function initMobileInteractions(container) {
    var drawer = document.querySelector('.shop-the-look__drawer');
    if (!drawer) return;

    var drawerClose = drawer.querySelector('.shop-the-look__drawer-close');
    var drawerImage = drawer.querySelector('.shop-the-look__drawer-image');
    var drawerProducts = drawer.querySelector('.shop-the-look__drawer-products');
    var items = container.querySelectorAll('.shop-the-look__item');
    var peekedItem = null;
    var activeDrawerItem = null;

    items.forEach(function (item) {
      item.addEventListener('click', function (event) {
        if (!isMobile()) return;
        if (event.target.closest('.shop-the-look__drawer')) return;

        event.preventDefault();
        event.stopPropagation();

        if (item.classList.contains('is-peek')) {
          openDrawer(item);
          clearPeek();
          return;
        }

        clearPeek();
        item.classList.add('is-peek');
        peekedItem = item;
      });
    });

    document.addEventListener('click', function (event) {
      if (!isMobile() || !peekedItem) return;
      if (peekedItem.contains(event.target)) return;
      if (drawer.classList.contains('is-open')) return;
      clearPeek();
    });

    drawerClose.addEventListener('click', closeDrawer);

    function clearPeek() {
      if (peekedItem) {
        peekedItem.classList.remove('is-peek');
        peekedItem = null;
      }
    }

    function openDrawer(item) {
      var products = item.querySelector('.shop-the-look__products');
      var primaryImage = item.querySelector('.shop-the-look__image--primary');

      if (!products || !primaryImage) return;

      setHeaderHeight();
      drawerImage.innerHTML = '';
      drawerProducts.innerHTML = '';

      var imageClone = primaryImage.cloneNode(true);
      imageClone.classList.remove('lazyload');
      if (imageClone.dataset.src) {
        imageClone.src = imageClone.dataset.src;
      }
      drawerImage.appendChild(imageClone);
      drawerProducts.appendChild(products);

      activeDrawerItem = item;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('shop-the-look-drawer-open');
      initProductCards(drawerProducts);
    }

    function closeDrawer() {
      if (!activeDrawerItem) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('shop-the-look-drawer-open');
        return;
      }

      var stage = activeDrawerItem.querySelector('.shop-the-look__stage');
      var products = drawerProducts.querySelector('.shop-the-look__products');

      if (stage && products) {
        stage.appendChild(products);
      }

      drawerImage.innerHTML = '';
      drawerProducts.innerHTML = '';
      activeDrawerItem = null;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('shop-the-look-drawer-open');
    }

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        clearPeek();
        closeDrawer();
      }
    });
  }

  function initProductCards(container) {
    container.querySelectorAll('.shop-the-look__product-form').forEach(function (form) {
      var variants = [];

      try {
        variants = JSON.parse(form.dataset.variants || '[]');
      } catch (error) {
        console.error('Shop the Look: failed to parse variant data', error);
        return;
      }

      var variantInput = form.querySelector('[data-variant-input]');
      var priceEl = form.querySelector('[data-price]');
      var addButton = form.querySelector('.shop-the-look__add-button');
      var sizeOptions = form.querySelectorAll('.shop-the-look__size-option');
      var optionIndex = parseInt(
        form.querySelector('[data-option-index]')?.dataset.optionIndex || '0',
        10
      );

      sizeOptions.forEach(function (button) {
        button.addEventListener('click', function () {
          var size = button.dataset.size;
          var variant = findVariant(variants, optionIndex, size); 
          if (!variant) return;

          sizeOptions.forEach(function (option) {
            option.classList.toggle('is-selected', option === button);
          });

          variantInput.value = variant.id;
          updateAddButton(addButton, variant);
          updatePrice(priceEl, variant);
        });
      });
    });
  }

  function findVariant(variants, optionIndex, size) {
    return variants.find(function (variant) {
      return variant.options[optionIndex] === size;
    });
  }

  function updateAddButton(button, variant) {
    if (!button) return;

    if (variant.available) {
      button.disabled = false;
      button.classList.remove('is-disabled');
      button.textContent = 'Add to cart';
    } else {
      button.disabled = true;
      button.classList.add('is-disabled');
      button.textContent = 'Sold out';
    }
  }

  function updatePrice(priceEl, variant) {
    if (!priceEl || !window.theme || !window.theme.money_format) return;

    priceEl.textContent = formatMoney(variant.price, window.theme.money_format);
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var moneyFormat = format || '${{amount}}';
    var match = moneyFormat.match(placeholder);
    if (!match) return moneyFormat;

    var value = '';

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return moneyFormat.replace(placeholder, value);
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(cents) || cents == null) return '0';

    var amount = (cents / 100).toFixed(precision);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsPart = parts[1] ? decimal + parts[1] : '';

    return dollars + centsPart;
  }
})();
